/**
 * The base shape of supported nouns as defined by data depot.
 * @see https://developer.atlassian.com/cloud/jsw-data-depot/supported-nouns/common-attributes-and-shapes/
 */

export var isDocumentEntity = function isDocumentEntity(entity) {
  return 'atlassian:document' in entity;
};

/**
 * The shape of the response from Native entity support by the Smart Link API.
 */